import React, { useEffect, useState } from 'react';

// 👉 Apunta directamente al backend que corre en puerto 4000
const apiBase = 'https://api.innerforcesports.com';

function App() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const fetchOrders = async () => {
    try {
      const res = await fetch(`${apiBase}/orders`);
      if (!res.ok) throw new Error('No se pudo obtener los pedidos');

      const data = await res.json();
      setOrders(data);
      setLoading(false);
      setError(false);
    } catch (err) {
      console.error('❌ Error fetching orders:', err);
      setError(true);
      setLoading(false);
    }
  };

  const updateOrder = async (id, status, client_event_date) => {
    try {
      const res = await fetch(`${apiBase}/orders/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ status, client_event_date }),
      });

      if (!res.ok) throw new Error('No se pudo actualizar el pedido');

      const data = await res.json();
      alert(data.message);
      fetchOrders(); // Refrescamos la tabla
    } catch (err) {
      console.error('❌ Error updating order:', err);
      alert('Hubo un problema actualizando el pedido.');
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  if (loading) return <p>Cargando pedidos...</p>;

  if (error) return <p>❌ Error cargando pedidos. Verifica que el backend esté corriendo.</p>;

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1>Pedidos Innerforce</h1>
      <table border="1" cellPadding="10" cellSpacing="0" style={{ borderCollapse: 'collapse', width: '100%' }}>
        <thead>
          <tr>
            <th>Order Number</th>
            <th>Status</th>
            <th>Client Event Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {orders.map((order) => {
            const statusOptions = ['Confirmed', 'Started Production', 'Sublimation', 'Sewing', 'Almost There'];

            return (
              <tr key={order.order_id}>
                <td>{order.order_number}</td>
                <td>
                  <select
                    defaultValue={order.status}
                    onChange={(e) => (order.status = e.target.value)}
                  >
                    {statusOptions.map((status) => (
                      <option key={status} value={status}>
                        {status}
                      </option>
                    ))}
                  </select>
                </td>
                <td>
                  <input
                    type="date"
                    defaultValue={
                      order.client_event_date
                        ? new Date(order.client_event_date).toISOString().split('T')[0]
                        : ''
                    }
                    onChange={(e) => (order.client_event_date = e.target.value)}
                  />
                </td>
                <td>
                  <button onClick={() => updateOrder(order.order_id, order.status, order.client_event_date)}>
                    Save
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default App;
